/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import TagManager from 'react-gtm-module';
import { Nullable } from 'types';
import { environmentManager, secretManager } from 'services/api/config';
import type { Analytics } from '../analytics';
import { AnalyticsEvent } from '../events';
import { AnalyticsLogger } from '../analyticsLogger';
import GTMLogger from './gtmLogger';
import type { GTMConfig } from './config';

export default class GTMAnalytics implements Analytics {
  private _logger: Nullable<AnalyticsLogger>;

  get logger(): Nullable<AnalyticsLogger> {
    return !environmentManager.isProductionEnv ? this._logger : null;
  }

  get config(): GTMConfig {
    return {
      gtmId: secretManager.gtmId,
      auth: secretManager.gtmAuth,
      preview: secretManager.gtmPreview,
    };
  }

  constructor() {
    this.init();
  }

  init(): void {
    this._logger = new GTMLogger();
    TagManager.initialize(this.config);
  }

  track(event: AnalyticsEvent): void {
    this.logger?.log(event);
    const args = {
      dataLayer: { ...event.parameters, event: event.name },
    };
    TagManager.dataLayer(args);
  }
}
